<div class="setbg bg-none" [ngClass]="headerData?.className">
  <div class="container-md px-5 px-md-0 hght100">
    <div class="row" *ngIf="!headerData?.stepperData || headerData?.stepperData">
      <div class="col-md-12">
        <header>
          <div class="row">
            <div class="col-6 d-flex flex-row align-items-center">
              <div class="image-parent">
                <img src="./../../../assets/images/logo.png" alt="logo" 
                [ngClass]="{ 'pointer': isPostLogin }" (click)="onClickToRedirectToHome()">
              </div>
              <h1 [ngClass]="{ 'pointer': isPostLogin }" (click)="onClickToRedirectToHome()">Creditors Central Portal</h1>
            </div>
            <div class="col-6 d-flex flex-row align-items-center justify-content-end" *ngIf="headerData.isHeaderRight">
              <ul class="list-inline header-right">
                <li (click)="onClickLogout()" class="list-inline-item pointer">Logout</li>
                <li class="list-inline-item" [matMenuTriggerFor]="menu">{{userName}}</li>
              </ul>
              <mat-menu #menu="matMenu" backdropClass="header-menu">
                <ul class="list-group list-group-flush" [ngClass]="{ 'matmenu-ddd': !isManageUser, 'matmenu-dd': isManageUser}" >
                  <li class="list-group-item" (click)="userdetails()">My Account</li>
                  <li  *ngIf="isManageUser" (click)="onCLickToNavigateToManageUser()" class="list-group-item">Manage Users</li>
                  <li class="list-group-item" (click)="onCLickToNavigateToFAQ()">FAQs</li>
                </ul>
              </mat-menu>
            </div>
          </div>
        </header>
        <div class="row" *ngIf="headerData?.isSubHeader">
          <div class="{{ headerData?.isSubHeaderRight ? 'col-md-10' : 'col-md-12' }}">
            <h2 *ngIf="headerData?.headTwo" class="mb-0">{{headerData?.headTwo}}</h2>
            <p class="m-0" *ngIf="headerData?.headTwoDesc" class="{{headerData?.isSubHeaderRightStatus ? 'font-twenty' : ''}}">
              {{headerData?.headTwoDesc}}
            </p>
            <div class="container-fluid">
              <div class="row">
                <h2 class="mb-0" *ngIf="headerData?.headThree">
                  {{headerData?.headThree}}</h2>
                <button class="claim-button ml-auto"
                        *ngIf="headerData?.subHeaderButtonText" (click)="redirectToRegistrationFilling()">
                        <img src="../../../../assets/images/creditor-portal/Add Claim.svg" alt="Add">
                  {{headerData?.subHeaderButtonText}}
                </button>
              </div>
            </div>
            <p class="m-0" *ngIf="headerData?.headThreeDesc">{{headerData?.headThreeDesc}}</p>
          </div>
          <div *ngIf="headerData?.isSubHeaderRight"
               class="{{headerData?.isSubHeaderRight ? 'col-md-2' : 'col-md-12'}}">
            <button class="claim-button"
                    *ngIf="headerData.subHeaderRightButtonLabel">
                    <img src="../../../../assets/images/creditor-portal/Add Claim.svg" alt="Add">
              {{headerData?.subHeaderRightButtonLabel}}
            </button>
            <div class="" *ngIf="headerData?.isSubHeaderRightStatus">
              <div>
                <div class="right-content">
                  <div class="d-flex justify-content-end align-items-center mt-5">
                    <div class="status-info">
                      <div class="status-icon d-flex align-items-center">
                        Adjudication Status
                        <span class="info-icon" [matTooltip]="headerData?.adjudicationStatusToolTip" matTooltipPosition="right"></span>
                      </div>
                      <div class="status-text">
                        {{headerData?.adjudicationStatus}}
                      </div>
                    </div>
                    <div *ngIf="headerData?.showWithdrawOption || headerData?.showSupportingDocumentOption" class="actions mt-5">
                      <button [matMenuTriggerFor]="menu">
                        <img src="assets/images/creditor-portal/More.svg" alt="moreIcon" width="15" height="15" />
                      </button>
                      <mat-menu #menu="matMenu" xPosition="before">
                        <button *ngIf="headerData?.showWithdrawOption"  (click)="onClickWithdraw()" mat-menu-item>Withdraw</button>
                        <button *ngIf="headerData?.showWithdrawOption && headerData?.showResubmit" (click)="onClickWithdrawResubmit()" mat-menu-item>Withdraw & Resubmit</button>
                        <div *ngIf="headerData?.showSupportingDocumentOption" mat-menu-item>
                          <div class="custom-overflow" [matTooltip]="supportingDocumentLabel" matTooltipPosition="right" (click)="onClickToOpenSupportingDocumentGrid(headerData?.adjudicationId,headerData?.engagementId);">{{supportingDocumentLabel}}</div>
                        </div>
                        <div *ngIf="headerData?.showSubmitOrViewMeetingGrid && showSubmitOrViewMeeting" mat-menu-item>
                          <div class="custom-overflow" [matTooltip]="submitOrViewMeetingLabel" matTooltipPosition="right" (click)="onClickToOpenSubmitOrViewMeetingGrid(headerData?.adjudicationId,headerData?.engagementId);">{{submitOrViewMeetingLabel}}</div>
                        </div>
                      </mat-menu>
                    </div>
                  </div>
                </div>

              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row align-items-center py-5" *ngIf="headerData.stepperData">
      <div class="col-md-12">
        <app-stepper [stepper-data]="headerData?.stepperData" (emitStepper)="emitStepper.emit($event)"></app-stepper>
      </div>
    </div>
  </div>
</div>
